import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { AppAdapter } from "../../../infraestructure/persistence/rest/AppAdapter";

 const StateAppContext = React.createContext();

 const StateAppProvider = ({ children }) =>{
  let [currentSettingsApp, setCurrentSettingsApp] = useState(undefined);

  const {data, isError, error , isLoading} = useQuery('getConfigurationAppProvider', getConfigurationApp, {refetchInterval: 40000})

  useEffect(()=> setCurrentSettingsApp(data),[data])

  return (
    <StateAppContext.Provider
      value={{
        currentSettingsApp: currentSettingsApp,
        setCurrentSettingsApp: (newCurrent) => setCurrentSettingsApp({ ...newCurrent }),
      }}
    >
      {children}
    </StateAppContext.Provider>
  );
}

const useStateApp = () => {
  const context = React.useContext(StateAppContext);

  if (!context) {
    throw new Error(`StateAppContext debe ser usado dentro de StateAppProvider`);
  }

  return context;
}

const getConfigurationApp = async () => {
    const api = new AppAdapter();
    try {
        var result = await api.GetConfiguracionApp();
        if(result.data!==undefined && result.data!==''){
            return result.data
        }
    } catch (error) {
    }
};

export { StateAppProvider, useStateApp };